<!DOCTYPE html>
<template>
  <div class="generic">
    <section class="anchor" id="jumbo">
    </section>

    <b-jumbotron bg-variant="primary"
                 text-variant="light"
                 header="Get in Touch"
                 lead="Click below to email us.">
      <b-button variant="success"
                @click="contact"
                class="shadow-lg">Contact Us</b-button>
    </b-jumbotron>

    <br>
    <br>

    <section class="anchor">
      <div class = "row">
        <div class = "col">

          <h2>Office Location</h2>
          <br>
          <h3>
          122 Grand Street
          </h3>
          <h3>
          New York, NY
          </h3>
          <h3>
          10013
          </h3>
        </div>
        <div class = "col">
          <iframe width="600" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJLwX2H9VZwokR7O4h9X-rWp4&key=AIzaSyBIqD2oYUIM17pPgP-9Zu0MkkOvqy_OAAk" allowfullscreen></iframe>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {}
  },
  metaInfo () {
    return {
      title: 'Contact',
      meta: [
        { name: "description", content: "Contact" },
        { name: "twitter:title", content: "BlueTeam - Contact Us", vmid: 'twitter:title' },
        { name: "og:image", content: "https://getblueteam.com/img/BlueTeamLogo.bb7395fa.png" },
        { name: "twitter:description", content: 'Where You Can Find BlueTeam', vmid: 'twitter:description' },
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }
  },
  props: {},
  computed: {},
  methods: {
  contact() {
    var link = "mailto:info@tailrisk.com"
             + "?cc=robert.terrin@tailrisk.com"
             + "&subject=" + escape("Hello BlueTeam");
    window.location.href = link;
  },
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";

.generic {
    color: theme-color-level('primary', 0);
}

</style>
